// BellyPiercingsData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const bellyPiercings: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Belly Piercing Dubai | Belly Piercing Near Me in Dubai UAE",
            "description": "Looking for belly piercing in Dubai? Explore professional belly piercing services near you in the UAE. Safe, stylish, and expertly done to enhance your look. Book your appointment today!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/belly-piercing-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Belly Piercing Dubai | Belly Piercing Near Me in Dubai UAE",
                "description": "Looking for belly piercing in Dubai? Explore professional belly piercing services near you in the UAE. Safe, stylish, and expertly done to enhance your look. Book your appointment today!",
                "url": "https://elitebodyhome.com/services/belly-piercing-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-16T13:09:01+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-13.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-13.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "belly piercing in dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Belly Piercing Dubai | Belly Piercing Near Me in Dubai UAE",
                "description": "Looking for belly piercing in Dubai? Explore professional belly piercing services near you in the UAE. Safe, stylish, and expertly done to enhance your look. Book your appointment today!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-13.jpg"
            },

        },
        "breadcrumbs": ["Home", "Services", "Belly Piercing Dubai"],
        "hero": {
            "title": "Belly Piercing Dubai",
            "subtitle": "Bold and Beautiful: Perfect Belly Piercing",
            "description": "What is Belly Piercing? What is Navel Piercing? This unique and fashionable look is created by placing a piece of jewellry into the skin around the navel. But, much like any body piercing, it takes a certain amount of thought, diligent aftercare, and an awareness of potential risks."
        },
        "howItWorks": {
            "title": "Belly Piercing Procedure",
            "description": "Article on Belly Piercing: All Duck and Cover-Up Secrets: Should you consider a belly piercing?"
        },
        "procedureSteps": {
            "heading": "",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "The professional piercer will explain the procedure, jewelry options and aftercare recommendations with you prior to the piercing.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Cleaning the Area",
                    "desc": "The area around the navel is cleaned and disinfected to avoid infection.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Marking the Piercing Spot",
                    "desc": "The piercer will mark the exact spot on your belly where the piercing will be placed based on where your anatomy is aligned.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "Piercing",
                    "desc": "What it Actually Entails: Using a sterilized hollow needle, he pierces a small hole in the skin in the marked spot. The jewelry is inserted into that hole.",
                    "icon": "fa-solid fa-cut"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "There are numerous benefits of belly piercing. Here's why so many people decide to get their navel pierced:",
            "items": [
                {
                    "title": "Self-expression",
                    "desc": "Belly piercings give people an opportunity to let their unique style and personality shine.",
                    "icon": "fa-solid fa-paint-brush"
                },
                {
                    "title": "Fashionable Accessory",
                    "desc": "There are multiple types of jewelry that can change the way the piercing looks to go with your clothes or feelings.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Confidence Boost",
                    "desc": "When it comes to body confidence, many feel a belly piercing does wonders in feeling good about themselves.",
                    "icon": "fa-solid fa-smile-beam"
                },
                {
                    "title": "Non-invasive Aesthetic Change",
                    "desc": "A belly piercing is an easy way to make a small and stylish alteration to your body without surgery or severe measures.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "The belly piercing is not suitable for everyone. There are some considerations that need to be made to make sure the procedure is safe and the piercing heals correctly.",
            "items": [
                {
                    "title": "You are over 18 years old",
                    "desc": "Parental consent is required for minors, depending on local regulations.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "You are in good health",
                    "desc": "Conditions such as diabetes or immune system problems can make the healing process more difficult.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "You don't experience skin sensitivities or allergies",
                    "desc": "Nickel allergies, for example, can lead to problems with some types of jewelry.",
                    "icon": "fa-solid fa-allergies"
                },
                {
                    "title": "You maintain proper hygiene",
                    "desc": "It is necessary to keep the piercing area clean during the healing process to prevent an infection.",
                    "icon": "fa-solid fa-hands-wash"
                },
                {
                    "title": "You have the right anatomy",
                    "desc": "The shape or size of some people's navels may not lend themselves to ideal placement of a piercing.",
                    "icon": "fa-solid fa-user-shield"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "If you are about to get your belly pierced and want to know how to prepare your body for the process, keep on reading! Here's how you can prepare for the procedure:",
            "items": [
                {
                    "title": "Wear Comfortable Clothing",
                    "desc": "Choose the right clothing — Challenger recommends loose-fitting clothes to prevent irritation around the navel after the piercing.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Eat Before Your Appointment",
                    "desc": "Eating something before you get pierced stabilizes your blood sugar, and when we do that, it's less likely you'll get faint.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Do not drink alcohol, take aspirin or any other blood thinner within the 24 hours before the procedure.",
                    "icon": "fa-solid fa-pills"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "This potentially delicate process is well worth it in the end, however; a fully healed belly piercing can add a tasteful, personal touch to your overall look. Once these piercings heal you can change them to various jewelry styles back-ons according to your taste. Although the results are permanent, the piercing can be removed if desired, but a tiny scar may still exist.",
            // "items": [
            //     {
            //         "title": "",
            //         "desc": "",
            //         "icon": ""
            //     }
            // ]
        },
        "aftercareTips": {
            "heading": "Aftercare and Healing",
            "subheading": "",
            "para": "In order to avoid complications, it is essential to have proper aftercare so that your belly piercing heals perfectly. To heal best, do the following:",
            "items": [
                {
                    "title": "Twice Daily Clean the Piercing",
                    "desc": "Clean the area with saline or a mild, fragrance-free soap.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "Avoid Touching the Piercing",
                    "desc": "Touch your piercing only with clean hands to avoid introducing bacteria into the wound.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "Be Careful with Clothing",
                    "desc": "Steer clear of tight-fitting clothes that might rub against the piercing and irritate it.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Do Not Soak the Piercing in Water",
                    "desc": "Avoid baths, hot tubs, and swimming until fully healed.",
                    "icon": "fa-solid fa-swimming-pool"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Does wart removal hurt?",
                    "answer": "Wart removal procedures, like cryotherapy or laser removal, may cause mild discomfort or a stinging sensation, but numbing options are available to reduce pain. Most patients report only minimal pain."
                },
                {
                    "question": "How long does the wart removal process take?",
                    "answer": "The process is usually quick, lasting 15–30 minutes depending on the size and number of warts being treated. Some warts may require multiple sessions for complete removal."
                },
                {
                    "question": "Will the wart come back after treatment?",
                    "answer": "While most treatments effectively remove warts, HPV remains in the body, so new warts can appear. Proper aftercare and follow-up treatments help minimize recurrence."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Minor side effects may include redness, swelling, or a blister at the treatment site. These are temporary and usually resolve within a few days."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-13.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Belly-Piercing-Dubais-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Belly-Piercing-Dubais-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Belly-Piercing-Dubais-3.jpg"

            ]
        },
        "product": {
            "id": 128,
            "title": "Belly Piercing",
            "price": 450,
            "description": "Looking for belly piercing in Dubai? Explore professional belly piercing services near you in the UAE. Safe, stylish, and expertly done to enhance your look. Book your appointment today!"
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "ثقب البطن في دبي | خدمات ثقب السرة في الإمارات العربية المتحدة",
            "description": "تبحث عن خدمات ثقب البطن في دبي؟ اكتشف خدمات ثقب السرة المحترفة بالقرب منك في الإمارات. آمن، أنيق، ويتم بإتقان لتعزيز مظهرك. احجز موعدك اليوم!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/belly-piercing-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "ثقب البطن في دبي | خدمات ثقب السرة في الإمارات العربية المتحدة",
                "description": "تبحث عن خدمات ثقب البطن في دبي؟ اكتشف خدمات ثقب السرة المحترفة بالقرب منك في الإمارات. آمن، أنيق، ويتم بإتقان لتعزيز مظهرك. احجز موعدك اليوم!",
                "url": "https://elitebodyhome.com/services/belly-piercing-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-16T13:09:01+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-13.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-13.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "ثقب البطن في دبي",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "ثقب البطن في دبي | خدمات ثقب السرة في الإمارات العربية المتحدة",
                "description": "تبحث عن خدمات ثقب البطن في دبي؟ اكتشف خدمات ثقب السرة المحترفة بالقرب منك في الإمارات. آمن، أنيق، ويتم بإتقان لتعزيز مظهرك. احجز موعدك اليوم!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-13.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "ثقب البطن في دبي"],
        "hero": {
            "title": "ثقب البطن في دبي",
            "subtitle": "إطلالة جريئة وجميلة: ثقب سرة مثالي",
            "description": "ما هو ثقب البطن أو ثقب السرة؟ هذا مظهر فريد وعصري يتم من خلال وضع قطعة من الحُلي في الجلد المحيط بمنطقة السرة. ولكن، مثل أي نوع من أنواع ثقب الجسم، فإنه يتطلب بعض التفكير المسبق، والعناية الدقيقة بعد الإجراء، والوعي بالمخاطر المحتملة."
        },
        "howItWorks": {
            "title": "إجراء ثقب البطن",
            "description": "مقال حول ثقب البطن: كل ما يجب معرفته - من الاستعداد إلى التعافي: هل يجب أن تفكر في الحصول على ثقب في البطن؟"
        },
        "procedureSteps": {
            "heading": "",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "سيشرح لك المتخصص خطوات إجراء الثقب، وأنواع الحُلي المتاحة، بالإضافة إلى تعليمات العناية بعد الإجراء قبل البدء.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "تنظيف المنطقة",
                    "desc": "تُنظف وتُعقم المنطقة المحيطة بالسرة جيدًا، لتقليل خطر الإصابة بالعدوى.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "تحديد موضع الثقب",
                    "desc": "يقوم المتخصص بتحديد الموضع الدقيق للثقب بناءً على شكل وتناسق منطقة السرة لديك.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "إجراء الثقب",
                    "desc": "ما الذي يحدث فعليًا؟ تًصنع فتحة صغيرة في المنطقة المحددة باستخدام إبرة مجوفة ومعقمة، ثم تُدخل قطعة الحُلي المناسبة في تلك الفتحة.",
                    "icon": "fa-solid fa-cut"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "",
            "para": "يتميز ثقب البطن بالعديد من الفوائد التي تجعل الكثيرين يقررون الحصول على ثقب في السرة، ومنها:",
            "items": [
                {
                    "title": "التعبير عن الذات",
                    "desc": "يمنح ثقب البطن الأفراد فرصة لإبراز أسلوبهم الخاص وشخصيتهم المميزة.",
                    "icon": "fa-solid fa-paint-brush"
                },
                {
                    "title": "حُلي عصري",
                    "desc": "يتوفر عدد كبير من أنواع الحُلي التي يمكن ارتداؤها في ثقب السرة، مما يتيح لكِ تغيير شكله بما يتناسب مع ملابسك أو حالتك المزاجية.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يشعر الكثيرون بثقة أكبر في مظهرهم بعد الحصول على ثقب في السرة.",
                    "icon": "fa-solid fa-smile-beam"
                },
                {
                    "title": "تغيير جمالي غير جراحي",
                    "desc": "يُعد ثقب السرة خياراً بسيطاً لإجراء تغيير بسيط وأنيق لجسمك دون الحاجة إلى جراحة أو إجراءات خطيرة.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "لا يُناسب ثقب البطن الجميع، وتوجد بعض النقاط التي يجب أخذها في الحسبان لضمان سلامة الإجراء وسرعة التعافي.",
            "items": [
                {
                    "title": "إذا كان عمرك فوق 18 عامًا",
                    "desc": "يتطلب الأمر موافقة الوالدين للقاصرين، وفقًا للقوانين المحلية.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "إذا كانت حالتك الصحية جيدة",
                    "desc": "قد يؤثر وجود حالات صحية مزمنة مثل السكري أو مشاكل في جهاز المناعة على قدرة الجسم على الشفاء السريع.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "إذا كنت لا تعاني من حساسية جلدية أو تحسس",
                    "desc": "مثل حساسية النيكل، والتي قد تُسبب مشكلات جلدية عند استخدام أنواع معينة من الحُلي.",
                    "icon": "fa-solid fa-allergies"
                },
                {
                    "title": "إذا كنت تهتم بالنظافة الشخصية",
                    "desc": "يجب الحفاظ على نظافة منطقة الثقب طوال فترة الشفاء لتفادي العدوى.",
                    "icon": "fa-solid fa-hands-wash"
                },
                {
                    "title": "إذا كان شكل السرة لديك ملائم",
                    "desc": "قد لا يتناسب ثقب البطن مع بعض الأشخاص بسبب شكل السرة أو حجمها.",
                    "icon": "fa-solid fa-user-shield"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "إذا كنت على وشك الحصول على ثقب في البطن وترغب في معرفة كيفية تحضير جسمك لهذه الخطوة، تابع القراءة! إليك كيف تستعد جيدًا قبل إجراء ثقب البطن:",
            "items": [
                {
                    "title": "ارتداء ملابس مريحة",
                    "desc": "اختاري ملابس مناسبة، يُوصى بارتداء ملابس فضفاضة لتقليل التهيّج في منطقة السرة بعد الثقب.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "تناول وجبة جيدة قبل الموعد",
                    "desc": "يساعد تناول الطعام قبل الإجراء على استقرار مستوى السكر في الدم، مما يقلل من احتمالية الشعور بالدوار أو الإغماء أثناء الثقب.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "تجنب مُميعات الدم",
                    "desc": "امتنع عن الكحول أو الأسبرين أو أي مُميعات للدم قبل 24 ساعة من الإجراء.",
                    "icon": "fa-solid fa-pills"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يُضفي ثقب البطن لمسة أنيقة ومعبرة عن الشخصية على مظهرك العام بعد التئامه الكامل، مما يجعله إجراء يستحق العناء. ويمكنك تغيير الحلي حسب ذوقك واختيار التصاميم التي تناسبك. ورغم أن النتائج تُعد دائمة، إلا أنه يمكن إزالة الثقب في أي وقت إن رغبتِ، مع احتمالية بقاء أثر بسيط أو ندبة صغيرة في مكانه.",
            // "items": [
            //     {
            //         "title": "",
            //         "desc": "",
            //         "icon": ""
            //     }
            // ]
        },
        "aftercareTips": {
            "heading": "العناية بعد الإجراء والتعافي",
            "subheading": "",
            "para": "يجب اتباع تعليمات العناية بعد الإجراء لضمان التئام ثقب البطن بشكل سليم ولتفادي أية مضاعفات. اتبعي الآتي لضمان أفضل شفاء:",
            "items": [
                {
                    "title": "تنظيف الثقب مرتين يومياً",
                    "desc": "نظّفي المنطقة باستخدام محلول ملحي أو صابون لطيف وخالٍ من العطور.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "تجنّبي لمس الثقب",
                    "desc": "لا تلمسي الثقب إلا بعد غسل اليدين جيداً لتجنب نقل البكتيريا إلى الجرح.",
                    "icon": "fa-solid fa-hand-paper"
                },
                {
                    "title": "امتنعي عن الملابس الضيقة",
                    "desc": "ابتعدي عن الملابس التي تضغط أو تحتك بمنطقة السرة لتفادي التهاب الجرح.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "لا تغمري الثقب بالماء",
                    "desc": "تجنب أحواض الاستحمام أو الساخنة، أو السباحة حتى تمام الشفاء.",
                    "icon": "fa-solid fa-swimming-pool"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل يسبب إزالة الثآليل الألم؟",
                    "answer": "قد تسبب إجراءات إزالة الثآليل مثل العلاج بالتبريد أو الليزر شعوراً بعدم الراحة أو لسعة خفيفة، ولكن تتوفر خيارات التخدير لتقليل الألم. معظم المرضى يبلغون عن ألم بسيط فقط."
                },
                {
                    "question": "كم تستغرق عملية إزالة الثآليل؟",
                    "answer": "عادة ما تكون العملية سريعة، وتستغرق من 15 إلى 30 دقيقة حسب حجم وعدد الثآليل المراد علاجها. قد تتطلب بعض الثآليل جلسات متعددة للإزالة الكاملة."
                },
                {
                    "question": "هل يمكن أن تعود الثآليل بعد العلاج؟",
                    "answer": "بينما تكون معظم العلاجات فعالة في إزالة الثآليل، يبقى فيروس الورم الحليمي البشري في الجسم، لذا قد تظهر ثآليل جديدة. تساعد العناية الجيدة والمتابعة في تقليل احتمالية العودة."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "قد تشمل الآثار الجانبية البسيطة احمراراً أو تورماً أو ظهور فقاعة في موقع العلاج. هذه الآثار مؤقتة وتختفي عادة خلال بضعة أيام."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
